import { authChannel } from "./authChannel";

const ACTIVITY_KEY = "auth:lastActivity";
const LOGOUT_LOCK_KEY = "auth:logoutInProgress";
const LOCK_TTL_MS = 10_000;

export const IDLE_TIMEOUT_MS = 10 * 60 * 1000;

export function markActivity() {
  const now = Date.now();
  localStorage.setItem(ACTIVITY_KEY, String(now));
}

export function getLastActivity() {
  const value = localStorage.getItem(ACTIVITY_KEY);
  return value ? Number(value) : Date.now();
}

export function broadcastActivity() {
  authChannel.postMessage({ type: "ACTIVITY" });
}

export function shouldAcquireLogoutLock() {
  const now = Date.now();
  const existing = Number(localStorage.getItem(LOGOUT_LOCK_KEY));

  if (existing && now - existing < LOCK_TTL_MS) {
    return false;
  }
  localStorage.setItem(LOGOUT_LOCK_KEY, String(now));
  return true;
}

export function releaseLogoutLock() {
  localStorage.removeItem(LOGOUT_LOCK_KEY);
}
